angular.module('app')
  .directive('passwordNumerals', function () {
    return {
      require: 'ngModel',
      link: (scope, element, attrs, controller) => {
        controller.$validators.passwordNumerals = (modelValue) => {
          if (!modelValue) {
            return true;
          }

          const numeralsRegex = /[0-9]/g;
          const numerals = modelValue.match(numeralsRegex);

          return (!!numerals && numerals.length > 0);
        };
      },
    };
  });
